//Declare All Helper Functions Here

class HelperFunctionsController {
    public GetObjKeyFromVal = (obj: any, val: any) => {
        let res: any = null;
        Object.keys(obj).map((key: any) => {
            if(obj[key] == val)
                res = key;
        });
        return res;
    }
    public ArrayBufferToBase64 = (buffer: any) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    public NumbersOnly = (subject: string) => {
        return subject.replace(/\D/g, "");
    }
    public AlpabetsOnly = (subject: string) => {
        return subject.replace(/[^a-zA-Z]/g, "");
    }
    public RemoveLastComma = (subject: string) => {
        if (subject.charAt(subject.length - 1) === ',') {
            return subject.slice(0, -1);  // Remove the last character
        }
        return subject;  // Return the string unchanged if it's not a comma
    }

    //checking functions
    public CheckMediaType = async(url: string) => {

        //first check for extension
        const ext = url.split('.').pop()?.toLowerCase();
        const imageExts = ['jpg','jpeg','png','gif','webp','svg'];
        const videoExts = ['mp4','webm','ogg','mov','avi'];

        console.log('checkExt: ' + ext);

        if(ext) {
            if (imageExts.includes(ext)) return 'image';
            else if (videoExts.includes(ext) || url.includes('youtube')) return 'video';
            else {
                //try fetch from url
                const response = await fetch(url, { method: 'HEAD' });
                const contentType = response.headers.get('Content-Type');

                if (!contentType) return 'unknown';
                if (contentType.startsWith('image/')) return 'image';
                if (contentType.startsWith('video/')) return 'video';
            }
        }

        return 'other';
    }
};
export default HelperFunctionsController;